import { onField, sentOff } from "@/lib/events";
import { teamStyle } from "@/lib/colors";

const Num = ({ n, starter, onClick, testId, style }) => (
  <button data-testid={testId} onClick={onClick} style={style}
    className={`tap h-14 border border-white/30 font-display text-2xl font-bold hover:ring-4 hover:ring-[#CCFF00] hover:z-10 ${starter ? "" : "opacity-55"}`}>
    {n}
  </button>
);

const TeamColumn = ({ side, match, playersOnly, onSelect }) => {
  const team = match[side];
  const field = onField(match, side);
  const off = sentOff(match, side);
  const offOfficials = sentOff(match, side, "official");
  const starters = team.players.filter((p) => field.has(String(p.number)));
  const subs = team.players.filter((p) => !field.has(String(p.number)) && !off.has(String(p.number)));
  const officials = team.officials.map((o, i) => [o, i]).filter(([o]) => !offOfficials.has(o));
  const expelled = [...[...off].map((n) => `Nº ${n}`), ...offOfficials];
  const grid = "grid grid-cols-5 sm:grid-cols-6 gap-2";
  const pick = (p) => () => onSelect({ team: side, target_type: "player", target: String(p.number) });
  return (
    <div data-testid={`target-team-${side}`} className="flex-1 min-w-0">
      <div className="flex items-baseline justify-between mb-3">
        <h3 className="font-display text-2xl font-bold uppercase truncate">{team.name}</h3>
        <span className="label-caps">{side === "home" ? "Casa" : "Fora"}</span>
      </div>
      <p className="label-caps mb-2">Em campo · {starters.length}</p>
      <div className={grid}>
        {starters.map((p) => <Num key={p.number} n={p.number} starter style={teamStyle(team)} testId={`target-${side}-player-${p.number}`} onClick={pick(p)} />)}
      </div>
      {subs.length > 0 && <p className="label-caps mt-4 mb-2">Banco / Substituídos</p>}
      <div className={grid}>
        {subs.map((p) => <Num key={p.number} n={p.number} style={teamStyle(team)} testId={`target-${side}-player-${p.number}`} onClick={pick(p)} />)}
      </div>
      {!playersOnly && officials.length > 0 && <p className="label-caps mt-4 mb-2">Elementos oficiais</p>}
      <div className="flex flex-wrap gap-2">
        {!playersOnly && officials.map(([o, i]) => (
          <button key={i} data-testid={`target-${side}-official-${i}`}
            onClick={() => onSelect({ team: side, target_type: "official", target: o })}
            className="tap px-4 h-12 border border-white/20 bg-[#131313] text-sm font-semibold hover:bg-[#CCFF00] hover:text-black">
            {o}
          </button>
        ))}
      </div>
      {expelled.length > 0 && <p data-testid={`target-${side}-expelled`} className="text-xs text-[#FF3B30] mt-4">Expulsos: {expelled.join(", ")}</p>}
    </div>
  );
};

export const TargetPicker = ({ match, playersOnly, onSelect }) => (
  <div className="flex flex-col md:flex-row gap-8">
    <TeamColumn side="home" match={match} playersOnly={playersOnly} onSelect={onSelect} />
    <div className="hidden md:block w-px bg-white/10" />
    <TeamColumn side="away" match={match} playersOnly={playersOnly} onSelect={onSelect} />
  </div>
);
